import styled from '@emotion/styled';
import { Typography, Flex } from '@robinpowered/ui-kit';

type PropTypes = {
  title: string;
  message?: string;
};

export const PageMessage = ({ title, message }: PropTypes): JSX.Element => {
  return (
    <Flex
      align="center"
      justify="center"
      vertical
      style={{
        paddingBottom: '25%',
        paddingTop: '24px',
      }}
    >
      <Typography.Title level={1}>{title}</Typography.Title>
      {message && <StyledBody>{message}</StyledBody>}
    </Flex>
  );
};

const StyledBody = styled(Typography.Text)`
  margin-top: 8px;
`;
